import { withSvg } from "core/components/svg/Svg";

export const AngleDown = withSvg(
    24,
    24
)(() => (
    <path d="M6.84941 8.99072C7.26883 8.6314 7.90012 8.68012 8.25944 9.09954L11.9981 13.4635L15.7409 9.09916C16.1004 8.67992 16.7318 8.63152 17.151 8.99104C17.5702 9.35057 17.6186 9.98188 17.2591 10.4011L12.7569 15.6511C12.5668 15.8727 12.2894 16.0002 11.9975 16.0001C11.7056 16.0001 11.4283 15.8724 11.2384 15.6507L6.7406 10.4007C6.38128 9.98133 6.43 9.35004 6.84941 8.99072Z" />
));
